import { Form } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import BaseField from 'components/Field';

interface StyledProps {
  $isDirty?: boolean;
}

export const Wrapper = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    height: 100vh;
  }
`;

export const FormContainer = styled(Form)<StyledProps>`
  padding: ${({ $isDirty }) => ($isDirty ? '0px 16px 132px 16px' : '0px 16px 32px 16px')};
  overflow-x: hidden;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
  }
`;

export const Container = styled.section`
  height: auto;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
    min-height: 100vh;
  }
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    padding-bottom: 40px;
  }
`;

export const Line = styled.div`
  width: 100%;
  padding-top: 32px;
  height: 1px;
  border-bottom: solid 1px ${ColorPalette.HEX.BrightGray};

  @media ${({ theme }) => theme.device.mobile} {
    margin-left: -16px;
    width: calc(100% + 32px);
  }
`;

export const Field = styled(BaseField)`
  margin-bottom: 16px;
`;

export const Title = styled.h4`
  font-size: 24px;
  font-weight: 600;
  margin: 32px 16px 16px;
  line-height: 1.33;
  letter-spacing: -0.4px;
  color: ${ColorPalette.HEX.PineTree};

  @media ${({ theme }) => theme.device.desktop} {
    margin: 32px 0 16px 0;
  }
`;

// Grid de 2 columnas para los campos de ubicación (Dirección/Descripción/País/Provincia/Ciudad),
// igual al patrón usado en screens/components/BillingCompany (components/Section > Content).
export const LocationFields = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 32px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;

  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
